import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _70f5ed77 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _5bd13c76 = () => interopDefault(import('..\\pages\\errors\\index.vue' /* webpackChunkName: "pages_errors_index" */))
const _1494eeaa = () => interopDefault(import('..\\pages\\thank-you.vue' /* webpackChunkName: "pages_thank-you" */))
const _1ba83de5 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _616daa95 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _6af91c83 = () => interopDefault(import('..\\pages\\upload-documents-success.vue' /* webpackChunkName: "pages_upload-documents-success" */))
const _8c896648 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _2f341efc = () => interopDefault(import('..\\pages\\hcp\\diagnosis-information.vue' /* webpackChunkName: "pages_hcp_diagnosis-information" */))
const _97e4d68e = () => interopDefault(import('..\\pages\\hcp\\eligibility.vue' /* webpackChunkName: "pages_hcp_eligibility" */))
const _0e49c0a4 = () => interopDefault(import('..\\pages\\hcp\\getting-started.vue' /* webpackChunkName: "pages_hcp_getting-started" */))
const _a1f673e8 = () => interopDefault(import('..\\pages\\hcp\\health-insurance-information.vue' /* webpackChunkName: "pages_hcp_health-insurance-information" */))
const _0c82a7e0 = () => interopDefault(import('..\\pages\\hcp\\patient-information.vue' /* webpackChunkName: "pages_hcp_patient-information" */))
const _0bf2cbd4 = () => interopDefault(import('..\\pages\\hcp\\pharmacy-information.vue' /* webpackChunkName: "pages_hcp_pharmacy-information" */))
const _1c663908 = () => interopDefault(import('..\\pages\\hcp\\prescriber-information.vue' /* webpackChunkName: "pages_hcp_prescriber-information" */))
const _1c08f02f = () => interopDefault(import('..\\pages\\hcp\\success.vue' /* webpackChunkName: "pages_hcp_success" */))
const _24d61609 = () => interopDefault(import('..\\pages\\patient\\eligibility.vue' /* webpackChunkName: "pages_patient_eligibility" */))
const _1dd14fc5 = () => interopDefault(import('..\\pages\\patient\\not-eligible.vue' /* webpackChunkName: "pages_patient_not-eligible" */))
const _4a9f632d = () => interopDefault(import('..\\pages\\patient\\patient-authorization.vue' /* webpackChunkName: "pages_patient_patient-authorization" */))
const _ad84d33a = () => interopDefault(import('..\\pages\\patient\\patient-authorization-success.vue' /* webpackChunkName: "pages_patient_patient-authorization-success" */))
const _184e4540 = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages_patient_patient-information" */))
const _6b127490 = () => interopDefault(import('..\\pages\\patient\\prescriber-information.vue' /* webpackChunkName: "pages_patient_prescriber-information" */))
const _3166997f = () => interopDefault(import('..\\pages\\patient\\success.vue' /* webpackChunkName: "pages_patient_success" */))
const _758682a9 = () => interopDefault(import('..\\pages\\pharmacy\\eligibility.vue' /* webpackChunkName: "pages_pharmacy_eligibility" */))
const _5a11bf7a = () => interopDefault(import('..\\pages\\pharmacy\\ncpdp.vue' /* webpackChunkName: "pages_pharmacy_ncpdp" */))
const _39a311b6 = () => interopDefault(import('..\\pages\\pharmacy\\not-eligible.vue' /* webpackChunkName: "pages_pharmacy_not-eligible" */))
const _09a887cd = () => interopDefault(import('..\\pages\\pharmacy\\patient-authorization.vue' /* webpackChunkName: "pages_pharmacy_patient-authorization" */))
const _1e22aa00 = () => interopDefault(import('..\\pages\\pharmacy\\patient-information.vue' /* webpackChunkName: "pages_pharmacy_patient-information" */))
const _26db95d0 = () => interopDefault(import('..\\pages\\pharmacy\\prescriber-information.vue' /* webpackChunkName: "pages_pharmacy_prescriber-information" */))
const _4786561f = () => interopDefault(import('..\\pages\\pharmacy\\success.vue' /* webpackChunkName: "pages_pharmacy_success" */))
const _2d2fcf41 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _70f5ed77,
    name: "error"
  }, {
    path: "/errors",
    component: _5bd13c76,
    name: "errors"
  }, {
    path: "/thank-you",
    component: _1494eeaa,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _1ba83de5,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _616daa95,
    name: "upload-documents"
  }, {
    path: "/upload-documents-success",
    component: _6af91c83,
    name: "upload-documents-success"
  }, {
    path: "/errors/404",
    component: _8c896648,
    name: "errors-404"
  }, {
    path: "/hcp/diagnosis-information",
    component: _2f341efc,
    name: "hcp-diagnosis-information"
  }, {
    path: "/hcp/eligibility",
    component: _97e4d68e,
    name: "hcp-eligibility"
  }, {
    path: "/hcp/getting-started",
    component: _0e49c0a4,
    name: "hcp-getting-started"
  }, {
    path: "/hcp/health-insurance-information",
    component: _a1f673e8,
    name: "hcp-health-insurance-information"
  }, {
    path: "/hcp/patient-information",
    component: _0c82a7e0,
    name: "hcp-patient-information"
  }, {
    path: "/hcp/pharmacy-information",
    component: _0bf2cbd4,
    name: "hcp-pharmacy-information"
  }, {
    path: "/hcp/prescriber-information",
    component: _1c663908,
    name: "hcp-prescriber-information"
  }, {
    path: "/hcp/success",
    component: _1c08f02f,
    name: "hcp-success"
  }, {
    path: "/patient/eligibility",
    component: _24d61609,
    name: "patient-eligibility"
  }, {
    path: "/patient/not-eligible",
    component: _1dd14fc5,
    name: "patient-not-eligible"
  }, {
    path: "/patient/patient-authorization",
    component: _4a9f632d,
    name: "patient-patient-authorization"
  }, {
    path: "/patient/patient-authorization-success",
    component: _ad84d33a,
    name: "patient-patient-authorization-success"
  }, {
    path: "/patient/patient-information",
    component: _184e4540,
    name: "patient-patient-information"
  }, {
    path: "/patient/prescriber-information",
    component: _6b127490,
    name: "patient-prescriber-information"
  }, {
    path: "/patient/success",
    component: _3166997f,
    name: "patient-success"
  }, {
    path: "/pharmacy/eligibility",
    component: _758682a9,
    name: "pharmacy-eligibility"
  }, {
    path: "/pharmacy/ncpdp",
    component: _5a11bf7a,
    name: "pharmacy-ncpdp"
  }, {
    path: "/pharmacy/not-eligible",
    component: _39a311b6,
    name: "pharmacy-not-eligible"
  }, {
    path: "/pharmacy/patient-authorization",
    component: _09a887cd,
    name: "pharmacy-patient-authorization"
  }, {
    path: "/pharmacy/patient-information",
    component: _1e22aa00,
    name: "pharmacy-patient-information"
  }, {
    path: "/pharmacy/prescriber-information",
    component: _26db95d0,
    name: "pharmacy-prescriber-information"
  }, {
    path: "/pharmacy/success",
    component: _4786561f,
    name: "pharmacy-success"
  }, {
    path: "/",
    component: _2d2fcf41,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
